import { getApiBaseUrl } from '@/config/env';

/**
 * Resolves API-relative file URLs for use in img/src/href (includes API base path).
 */
export function resolveFileUrl(path: string | undefined | null): string | undefined {
  if (!path) {
    return undefined;
  }
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }
  const base = getApiBaseUrl();
  return path.startsWith('/') ? `${base}${path}` : `${base}/${path}`;
}
